module.exports = __webpack_public_path__ + "static/media/22.47c965cc.mp4";